import AnimatedContent from './AnimatedContent';
import CourseContentAdapter from './CourseContentAdapter';

export {
  AnimatedContent,
  CourseContentAdapter
};

export default CourseContentAdapter; 